import "./App.css";
import Footer from "./functions/Footer.js";
import ProjHead from "./functions/ProjHead.js";
import React from "react";
import Bottom from "./functions/Bottom.js";
import Zoom from "./functions/Zoom.js";
function GSoC(props) {
  return (
    <div>
      <div className="bodytext">
        {/* <hr/> */}
        <ProjHead
          title="p5.js 2020 Showcase"
          description="Curating, designing, and developing an online gallery for the creative computing community"
          context="Google Summer of Code"
          image="p5/showcase.gif"
          timeline="May-Aug 2020"
          role="Role"
          team="Designer and Developer"
          tools="Figma, React.js, Data Viz JS Libraries"
        />
        <div className="projmargins">
          <p>
            <strong>
              View the live site{" "}
              <a href="https://connie-liu.me/p5.js-showcase" target="_blank">
                here
              </a>{" "}
              and read the Medium article{" "}
              <a
                href="https://medium.com/processing-foundation/increasing-the-organization-and-scope-of-the-p5-js-showcase-7193ef558c5a"
                target="_blank"
              >
                here
              </a>{" "}
            </strong>{" "}
            Currently has been visited by over 100k users and has 6k monthly
            page views
          </p>
          <p>
            To learn more about the <strong>development process</strong>, check
            out the{" "}
            <a
              href="https://github.com/connieliu0/p5.js-showcase"
              target="_blank"
            >
              GitHub
            </a>
          </p>
          <h2>Overview</h2>
          <div className="forty">
            <p>
              The p5.js showcase was established last year by a previous GSoC
              student and consisted of six projects (view{" "}
              <a href="https://p5js.org/showcase/">here</a>). This year I
              proposed expanding the showcase to hold more projects and allow
              for easier searching of projects that would pique the user's
              interest.
            </p>
            <p>
              Users who came to the p5.js showcase website were often{" "}
              <strong>novices</strong>. This meant that they wanted a site that
              would allow them to quickly see the possibilities of the type of
              projects they'd be looking at as well as scan the technologies
              used. Organization was especially important as my project grew the
              showcase ten times.
            </p>
            <h2>UX Redesign</h2>
            <p>
              The current problem with the p5.js showcase (see image below) was
              that it was unclear what each project composed of, as the user
              would have to read each description to determine what it was.
              Scanning was difficult because images were of different sizes and
              text was located at different points. With my redesign, I focused
              on standardizing UI for easy scannability and allowing the user to
              filter through the projects, which is important especially if they
              already know what kind of project they're looking for.
            </p>
            <Zoom src="p5/comparison.png" img alt="comparing looks" />
            <h2>Implementing Changes through Development</h2>
            <p>
              Initially, I was going to integrate the showcase into the original
              codebase of the p5.js website. However, after a month of auditing
              and trying different solutions (and contacting many people in the
              community to make sense of it), I came to the conclusion that for
              what I wanted to do- which was autogenerating 50 projects and
              having a filter for each, it would be very difficult to do it
              within the current Handlebars framework. As a result, I planned a
              new proposal to use a React Framework in which I would be able to
              autogenerate different UI using content from the JSON files.
            </p>
            <h2>i18next Integration</h2>
            <p>
              Figuring out how to integrate i18next into the React framework was
              one of the biggest challenges I faced. It took three days of
              rereading the same docs over and over again, and I still could not
              figure out how translations worked with nested JSON arrays. After
              stumbling onto a GitHub thread from a couple of years ago I was
              finally able to figure out the syntax.
            </p>
            <p>
              Because of the problems I had with figuring out the previous tech
              stack of the website and with creating the new one, as part of my
              project I wrote up brief{" "}
              <a href="https://github.com/connieliu0/p5.js-showcase/blob/master/showcase2020_documentation.md">
                documentation
              </a>{" "}
              about how i18next worked with the JSON files.
            </p>
            <h2>Designing the Data Visualizations</h2>
            <p>
              Another challenge was figuring out what data visualizations I
              wanted in the beginning. In my original iteration, I focused on
              splitting it up into three different categories. However, that
              ruined the linear narrative flow and all the different
              visualizations felt very separate from one another. At one point,
              I just had a series of graphs that were auto-generated by the
              Google Form. I also had planned to use d3.js but my mentors
              encouraged me to change my approach to different JS libraries that
              were more tailored towards the graph types I was planning for.
            </p>
            <img src="p5/data1.png" img alt="dataviz" />
            <p>
              The one advice my mentor told me that really stuck with me was to
              design the visualizations for a story. In my final iteration, I
              made sure that the visualizations acted as part of a narrative,
              and incorporated it with a sentence that explained the
              significance of the visuals.
            </p>
            <img src="p5/data2.png" img alt="dataviz2" />
            <h2>Designing the Gallery</h2>
            <p>
              In my initial iteration of the gallery I initially thought about
              separating the works by topic as seen below.
            </p>
            <img src="p5/galleryold.png" img alt="gallery" />
            <p>
              However I soon realized that it was better to show the users
              upfront what they could filter through. Because there were so many
              different works in the end- the filter worked much better than a
              static page. Below is the final gallery.
            </p>
            <img src="p5/gallerynew.png" img alt="gallery" />
            <h2>Organizing the Submissions</h2>
            <p>
              Another thing that changed this year was that I reached out to
              many different institutions and people to try and increase the
              number of submissions. As a result, the showcase grew to 60
              submissions! In order to make it easier for people to find what
              they were interested in among all the submissions, I split them up
              into 11 different categories. I also put tags on the bottom of
              each entry to give more context to the technologies used.
            </p>
            <p>
              In order to get more people to submit and also check out the
              showcase, I created some marketing graphics. It was a challenge
              for me, as someone who hadn’t created graphic designs in a while,
              but it was worth it and I learned a lot.
            </p>
            <img src="p5/market.png" img alt="gallery" />
            <h2>Final Product</h2>
            <ul>
              <li>
                Added translation support and implemented translations for
                Spanish and Chinese
              </li>
              <li>
                Implemented data visualizations with Leaflet.js, p5.js, and
                Chart.js
              </li>
              <li>Added filters for various project categories</li>
              <li>
                Added tool tags for various niche libraries and functions used
                in p5.js
              </li>
              <li>Created documentation for translation contributions</li>
            </ul>
            <h2>Future</h2>
            <p>
              Currently, I am the maintainer of the p5.js 2020 showcase repo and
              it exists within my GitHub account. The hope is that next summer’s
              GSoC student can take over as the maintainer, or work to expand
              the showcase into an official system that can be maintained by a
              team of people. Another goal is to make sure that the showcase is
              accessible to everyone as there wasn’t enough time to make sure it
              complied with a11y guidelines.
            </p>
            <p>
              I hope that the showcase can be expanded every year or two years
              as a celebration of people’s work. I truly believe it’s a unique
              opportunity to bring the p5.js community together to recognize
              everyone's work.
            </p>
            <h2>Acknowledgements</h2>
            <p>
              Furthermore, I’d like to extend my deepest thanks to my mentors,
              Joey Lee and Yining Shi for helping me throughout the whole
              process and providing advice for everything from curation to
              career. There are many others I’d also like to thank, click{" "}
              <a href="https://github.com/processing/p5.js/blob/main/contributor_docs/project_wrapups/connieliu_gsoc_2020.md#acknowledgements">
                here
              </a>{" "}
              for the full list!
            </p>
          </div>
        </div>
        <Bottom nextproject="Arcade: Gaming for Seniors" next="/arcade" />
      </div>

      <Footer />
    </div>
  );
}
export default GSoC;
